<template>
    <div class="relative">

        <div class="flex flex-row items-center justify-center h-8">
            <i class="material-icons text-theme-copy3 w-0 rounded-l-full icon-sm icon-compensate h-full bg-theme-level5 md:w-8 outline-none">search</i>
            <label for="searchbar" class="invisible w-0">Search</label>

            <input id="searchbar" name="searchbar" type="text"
                   v-model="query"
                   @blur="searchResultsVisible = false"
                   @focus="searchResultsVisible = true"
                   @keydown.esc="searchResultsVisible = false"
                   @input="softReset"
                   ref="search"
                   @keyup="performSearch"
                   @keydown.up.prevent="highlightPrevious"
                   @keydown.down.prevent="highlightNext"
                   @keydown.enter="gotoLink"
                   class="bg-theme-level5 appearance-none w-3/5 px-3 text-theme-copy3 h-full leading-tight focus:outline-none rounded-r-full"
                   :placeholder="translate('searchbar-placeholder')"
                   autocomplete="off"
            />

            <div v-if="query.length > 0"
                 class="absolute top-0 right-0 text-2xl mr-3 cursor-pointer text-theme-muted hover:text-theme-main"
                 style="top: 4px; right: 19%;"
                 @click="reset"
            >
                &times;
            </div>

        </div>

        <div v-if="query.length > 0 && searchResultsVisible"
             class="absolute bg-theme-level4 rounded-lg shadow-2xl mt-1 inline-block
                    w-2/3 transform -translate-x-1/2 z-10
                    overflow-y-scroll flex flex-col text-left disable-scrollbars"
             style="left: 50%; min-width: 30rem; max-height: 32rem;"
             ref="resultsPanel">

            <!--<h1 class="text-theme-title font-bold text-xl text-center my-4">Resultados de la Búsqueda</h1>-->

                <a v-for="(searchableSource, index) in searchResults" :key="index"
                    :href="'/view/' + searchableSource.item.id"
                    @mousedown.prevent.stop="gotoLinkWithIndex(index)"
                    @click.prevent.stop="gotoLinkWithIndex(index)"
                    :class="{'bg-theme-level2': index === highlightedIndex}"
                    class="border-b border-theme-level2 text-lg px-8 pt-8 pb-6 cursor-pointer hover:bg-theme-level2 text-theme-title hover:text-theme-main mb-4"
                >
                    {{ searchableSource.item.title }}

                    <span class="block font-normal text-sm my-2 text-theme-discrete mb-4 leading-normal">
                        <strong v-text="translate('searchbar-category')"></strong> {{ searchableSource.item.categories }}<br />
                        <strong v-text="translate('searchbar-tag')"></strong> {{ searchableSource.item.tags }}
                    </span>
                </a>

            <div v-if="searchResults.length === 0" class="font-normal w-full border-b px-6 py-4">
                <p class="my-0 text-theme-discrete">{{ translate('searchbar-not-found') }} <span class="text-theme-main">'<strong>{{ query }}</strong>'</span></p>
            </div>
            <!--<p class="text-justify overflow-y-scroll" style="max-height: 500px;"></p>-->

        </div>
    </div>
</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {
            return {
                query: '',
                searchResultsVisible: false,
                searchableSource: [],
                searchResults: [],
                highlightedIndex: 0,
                options: {
                    shouldSort: true,
                    includeMatches: true,
                    threshold: 0.5,
                    location: 0,
                    distance: 500,
                    maxPatternLength: 32,
                    minMatchCharLength: 1,
                    keys: ['title', 'categories', 'tags']
                }
            }
        },

        props: [
            'currentlocale'
        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            reset() {
                this.query = '';
                this.highlightedIndex = 0;
            },

            softReset() {
                this.searchResultsVisible = true;
                this.highlightedIndex = 0;
            },

            performSearch() {

                this.$search(this.query, this.searchableSource, this.options)
                    .then(results => {
                        this.searchResults = results
                    })

            },

            highlightPrevious() {
                if(this.highlightedIndex > 0) {
                    this.highlightedIndex--;
                } else {
                    this.highlightedIndex = this.searchResults.length - 1;
                }

                this.scrollIntoView();

            },

            highlightNext() {
                if(this.highlightedIndex < this.searchResults.length - 1) {
                    this.highlightedIndex++;
                } else {
                    this.highlightedIndex = 0;
                }

                this.scrollIntoView();
            },

            scrollIntoView() {
                this.$refs.resultsPanel.children[this.highlightedIndex].scrollIntoView({ block: 'nearest'});
            },

            gotoLink() {
                if(this.searchResults[this.highlightedIndex]) {

                    /*let contentPiece = '';*/
                    /*let catsArray = [];*/

                    axios.get('/api/content/' + this.searchResults[this.highlightedIndex].item.id)
                        .then(response => {
                            console.log('Showing content from Search bar...');
                            this.searchResultsVisible = false;
                            Event.fire('showPlayer', { language: this.currentlocale, data: response.data });
                            /*contentPiece = response.data*/
                        })
                        .catch(error => {
                            console.log('Error from Seacrh Bar: ' + JSON.stringify(error));
                        });

                    /*axios.get('/api/content/data?contentId=' + this.searchResults[this.highlightedIndex].item.id)
                        .then(response => {
                            catsArray = response.data
                        });*/

                    /*this.$root.shared.playerPayload = contentPiece;
                    this.$root.shared.playerCategories = catsArray;*/



                    /*window.location = '/view/' +  this.searchResults[this.highlightedIndex].item.id*/
                }
            },

            gotoLinkWithIndex(index) {
                if(this.searchResults[index]) {

                    /*let contentPiece = '';*/
                    /*let catsArray = [];*/

                    axios.get('/api/content/' + this.searchResults[index].item.id)
                        .then(response => {
                            console.log('Showing content from Search bar...');
                            this.searchResultsVisible = false;
                            Event.fire('showPlayer', { language: this.currentlocale, data: response.data });
                            /*contentPiece = response.data*/
                        })
                        .catch(error => {
                            console.log('Error from Seacrh Bar: ' + JSON.stringify(error));
                        });

                    /*axios.get('/api/content/data?contentId=' + this.searchResults[this.highlightedIndex].item.id)
                        .then(response => {
                            catsArray = response.data
                        });*/

                    /*this.$root.shared.playerPayload = contentPiece;
                    this.$root.shared.playerCategories = catsArray;*/



                    /*window.location = '/view/' +  this.searchResults[this.highlightedIndex].item.id*/
                }
            }
        },

        created() {

            if(this.currentlocale==='es') {
                axios.get('/api/searchindex')
                    .then(response => {
                        this.searchableSource = response.data
                    });
            } else {
                axios.get('/api/searchenindex')
                    .then(response => {
                        this.searchableSource = response.data
                    });
            }

        },

        mounted() {
            console.log('SearchBar component mounted.')
        }
    }
</script>
